import React from "react";
import uploadIcon from "../../../../assets/icons/upload.webp";
import { UploadButtonContainer, HiddenFileInput } from "./index.styled";

interface UploadButtonProps {
  isUploading: boolean;
  isUploaded: boolean;
  onFileSelect: (file: File) => void;
  onError?: (error: string) => void;
  accept?: string;
  maxSizeInMB?: number;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  isUploading,
  isUploaded,
  onFileSelect,
  onError,
  accept = "image/*,video/*",
  maxSizeInMB = 16,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024; // Convert MB to bytes

      if (file.size > maxSizeInBytes) {
        const errorMessage = `קובץ גדול מדי. גודל מקסימלי: ${maxSizeInMB} מגה`;
        onError?.(errorMessage);
        return;
      }

      onFileSelect(file);
    }
  };

  return (
    <UploadButtonContainer $isUploading={isUploading} $isUploaded={isUploaded}>
      <img src={uploadIcon} alt="Upload" />
      <HiddenFileInput
        type="file"
        accept={accept}
        onChange={handleFileChange}
      />
    </UploadButtonContainer>
  );
};

export default UploadButton;
